import script from "./CampaignsManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./CampaignsManagement.vue?vue&type=script&lang=ts&setup=true"

import "./CampaignsManagement.vue?vue&type=style&index=0&id=6b9f231b&lang=scss"

const __exports__ = script;

export default __exports__